export default __webpack_public_path__ + "static/media/534.eaebc988.png";